import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11a266df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-group" }
const _hoisted_5 = { class: "option-label" }
const _hoisted_6 = { class: "option-row align-center" }
const _hoisted_7 = { class: "option-row align-center" }
const _hoisted_8 = { class: "option-group" }
const _hoisted_9 = { class: "option-label" }
const _hoisted_10 = {
  key: 0,
  class: "option-group"
}
const _hoisted_11 = { class: "option-label" }
const _hoisted_12 = { class: "option-group" }
const _hoisted_13 = { class: "option-label" }
const _hoisted_14 = { class: "option-group" }
const _hoisted_15 = { class: "option-label" }
const _hoisted_16 = { class: "option-row" }
const _hoisted_17 = { class: "cm-ui-mt5" }
const _hoisted_18 = { style: {"position":"relative","top":"-1px"} }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { VirusDetectionSettings } from '../../../../group-policy-settings.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'virus-detection',
  props: {
  modelValue: {
    type: Object as PropType<VirusDetectionSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.vdFileTypesTitle')), 1),
      _createVNode(_component_el_radio_group, {
        modelValue: strategy.value.scan_all_file,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.scan_all_file) = $event)),
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdScanAllTypes')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdScanProgDocOnly')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('groupPolicySettings.vdScanMethodTitle')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_checkbox, {
          modelValue: strategy.value.fullscan_extract,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.fullscan_extract) = $event)),
          modelModifiers: { number: true },
          "true-label": 1,
          "false-label": 0,
          disabled: __props.readonly,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdFullScanEnterArchive')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_tooltip, {
          content: _unref(t)('groupPolicySettings.vdArchiveEncryptedTip'),
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", null, [
              _createVNode(_component_CmSvgIcon, {
                name: "assets/icons/blue_tips",
                class: "cm-ui-ml5",
                monochrome: "",
                "aria-hidden": false,
                "aria-label": "info"
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "option-row",
            modelValue: strategy.value.fullscan_cdrom,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.fullscan_cdrom) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdFullScanCdrom')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_checkbox, {
          modelValue: strategy.value.customscan_extract,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.value.customscan_extract) = $event)),
          modelModifiers: { number: true },
          "true-label": 1,
          "false-label": 0,
          disabled: __props.readonly,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdCustomScanEnterArchive')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_tooltip, {
          content: _unref(t)('groupPolicySettings.vdArchiveEncryptedTip'),
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", null, [
              _createVNode(_component_CmSvgIcon, {
                name: "assets/icons/blue_tips",
                class: "cm-ui-ml5",
                monochrome: "",
                "aria-hidden": false,
                "aria-label": "info"
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('groupPolicySettings.vdOnVirusTitle')), 1),
      _createVNode(_component_el_radio_group, {
        modelValue: strategy.value.auto_fix_file,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.value.auto_fix_file) = $event)),
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdHandleManual')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio, {
            class: "option-row",
            label: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdHandleAuto')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.backup_file,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.value.backup_file) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdBackupBeforeClean')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('groupPolicySettings.vdScanModeTitle')), 1),
          _createVNode(_component_el_radio_group, {
            modelValue: strategy.value.strong_scan,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((strategy.value.strong_scan) = $event)),
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                class: "option-row",
                label: 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdScanModeSmart')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                class: "option-row",
                label: 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdScanModeStrong')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('groupPolicySettings.vdMacroRepairTitle')), 1),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.macro_deepScan,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((strategy.value.macro_deepScan) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdMacroStrictOffice')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('groupPolicySettings.vdExecConfig')), 1),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_checkbox, {
          modelValue: strategy.value.light_weight_switch,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((strategy.value.light_weight_switch) = $event)),
          modelModifiers: { number: true },
          "true-label": 1,
          "false-label": 0,
          disabled: __props.readonly,
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.vdLightMode')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('groupPolicySettings.vdLightModeLine1')), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('groupPolicySettings.vdLightModeLine2')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("i", _hoisted_18, [
              _createVNode(_component_CmSvgIcon, {
                name: "assets/icons/info-gray",
                size: 18,
                style: {"position":"relative","left":"5px"},
                monochrome: "",
                "aria-hidden": false,
                "aria-label": "info"
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})